
import React from 'react'
import TaskCard from '../TaskCard'
import EmptyState from '../EmptyState'

interface InspirationTask {
  id: string
  taskData: {
    id: string
    title: string
    description: string | null
    module: string | null
    domain: string | null
    priority: boolean
  }
}

interface InspoTasksListProps {
  inspirations: InspirationTask[]
  onAddInspirationTask: (inspiration: InspirationTask) => void
}

const InspoTasksList: React.FC<InspoTasksListProps> = ({ inspirations, onAddInspirationTask }) => {
  const hasQuizBasedInspirations = inspirations.length > 0

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Inspo Tasks</h2>
      <div className="space-y-3">
        {hasQuizBasedInspirations ? (
          inspirations.map(inspiration => (
            <div key={inspiration.id} className="border-l-4 border-l-purple-500 bg-gradient-to-r from-purple-50 to-transparent">
              <TaskCard 
                task={{
                  id: inspiration.taskData.id,
                  title: inspiration.taskData.title,
                  module: inspiration.taskData.module || undefined,
                  description: inspiration.taskData.description || undefined,
                  badge: 'Recommended',
                  priority: inspiration.taskData.priority
                }}
                showBadge={true}
                showActions={true}
                actionType="add"
                onAction={() => onAddInspirationTask(inspiration)}
              />
            </div>
          ))
        ) : (
          <EmptyState title="Inspo Tasks" message="Complete a quiz to get personalized task recommendations!" />
        )}
      </div>
    </div>
  )
}

export default InspoTasksList
